import { SectionLabel, Reveal } from "../landing/shared";

export default function ProofPlaceholders() {
  return (
    <section className="py-24 px-6 lg:px-10 bg-white/[0.015]" data-testid="proof-section">
      <div className="max-w-6xl mx-auto">
        <Reveal>
          <SectionLabel n="006" text="IN THEIR WORDS" />
        </Reveal>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {[1, 2, 3].map((i) => (
            <Reveal key={i} delay={i * 0.08}>
              <div
                className="border-2 border-dashed border-[#0162CA] opacity-40 p-8 min-h-[180px] flex items-center justify-center"
                data-testid={`testimonial-placeholder-${i}`}
              >
                <p className="font-mono-strict text-[11px] tracking-[0.1em] text-center leading-relaxed">
                  [VERIFIED TESTIMONIAL — REPLACE WITH REAL, PERMISSIONED CLIENT QUOTE]
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
